(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  const cartForm = document.getElementById('cart');
  cartForm.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      e.target.blur();
      document.getElementById('update-button').click();
    }
  });

  cartForm.addEventListener('submit', function (e) {
    console.log('SUBMIT');
    const cartForm = document.getElementById('cart');

    console.log(cartForm);
    // Check validity - we do this again here because we're calling submit() elsewhere
    if (!cartForm.reportValidity()) {
      console.log('Validity Error');
      cartForm.reportValidity()
      e.preventDefault(); // Stop the form submission
      return;
    }

    let submitter = e.submitter;
    let submitAction = e.submitter?.name || 'unknown';
    if (e.submitter.matches('.input-quantity button')) {
      submitAction = 'update'; // TODO: This should be 'change' but we'll need to rewrite the debounce to account for separating line items
    }

    const sections = ['cart-items', 'cart-summary', 'cart-bubble', 'cart-callouts'];

    switch (submitAction) {
      case 'checkout':
        // Let's checkout!

        return;
      case 'update': {
        // Full cart update
        e.preventDefault();

        let updates = {};

        sections.push('cart-footer');

        document.querySelectorAll('[name="updates[]"]').forEach((input) => {
          let key = input.id;
          let quantity = parseInt(input.value, 10);
          updates[key] = quantity;
        });

        sections.forEach((wrapper) => {
          document.getElementById(wrapper).classList.add('section-loading');
        });

        let note = document.querySelector('textarea[name="note"]')?.value;

        let current_discounts = document.querySelector('[name="current_discounts"]').value;
        let discount = document.querySelector('[name="discount_code"]').value;

        const body = { updates: updates, note: note, sections: sections };

        if (discount) {
          body.discount = [current_discounts.trim(), discount.trim()].join(',');
        }

        if (discount == ' ') {
          body.discount = current_discounts;
        }

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        })
          .then((res) => {
            if (res.bodyUsed) {
              return null;
            }
            return res.json();
          })
          .then((cart) => {
            if (!cart) {
              updateSections(sections, 'cart').then(initCart);
              return;
            }
            if (cart.message) {
              popupMessage(cart.message, 'error');
            }

            if (cart.discount_codes) {
              cart.discount_codes.forEach((code) => {
                if (!code.applicable) {
                  // popupMessage(`Sorry, the code '${code.code}'' is not available.`, 'error');
                }
              });
            }

            if (cart.sections) {
              replaceSections(cart.sections);
              initCart();
            } else {
              updateSections(sections, 'cart').then(initCart);
            }
          });
        return;
      }
      case 'change': {
        // Change line item
        e.preventDefault();

        let updates = {};

        let updateInput = submitter;

        if (submitter.tagName == 'BUTTON') {
          updateInput = document.getElementById(submitter.dataset.input);
        }

        updates.id = updateInput.dataset.input;
        updates.quantity = updateInput.value;

        if (updateInput.dataset.decimal) {
          updates.quantity = updateInput.value * 10;
        }

        sections.forEach((wrapper) => {
          document.getElementById(wrapper).classList.add('section-loading');
        });

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ...updates, sections }),
        })
          .then((res) => {
            if (res.bodyUsed) {
              return null;
            }
            return res.json();
          })
          .then((cart) => {
            if (!cart) {
              updateSections(sections, 'cart').then(initCart);
              return;
            }
            if (cart.message) {
              popupMessage(cart.message, 'error');
            }

            if (cart.sections) {
              replaceSections(cart.sections);
              initCart();
            } else {
              updateSections(sections, 'cart').then(initCart);
            }
          });
        return;
      }
      case 'clear': {
        // Change line item
        e.preventDefault();

        sections.forEach((wrapper) => {
          document.getElementById(wrapper).classList.add('section-loading');
        });

        fetch('/cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
        })
          .then((res) => {
            if (res.bodyUsed) {
              return null;
            }
            return res.json();
          })
          .then((cart) => {
            if (!cart) {
              updateSections(sections, 'cart').then(initCart);
              return;
            }
            if (cart.message) {
              popupMessage(cart.message, 'error');
            }

            if (cart.sections) {
              replaceSections(cart.sections);
              initCart();
            } else {
              updateSections(sections, 'cart').then(initCart);
            }
          });
        return;
      }
    }
    e.preventDefault();
    console.error('Submit action not handled');
    // return;
  });

  function initCart() {
    const cartData = JSON.parse(document.getElementById('cart-data')?.innerText);

    document.querySelectorAll('.input-quantity__wrapper').forEach((el) => QtyBox.register(el));

    document.querySelectorAll('.cart-messages').forEach((messageElement) => {
      messageElement.innerHTML = '';
    });

    cartData?.messages.forEach((message) => {
      document.querySelectorAll('.cart-messages').forEach((messageElement) => {
        messageElement.innerHTML += `<div class="message ${message.type}">${message.content}</div>`;
      });
    });

    if (cartData.has_error) {
      document.querySelectorAll('input[name="checkout"]').forEach((checkoutBtn) => {
        checkoutBtn.disabled = true;
      });
    } else {
      document.querySelectorAll('input[name="checkout"]').forEach((checkoutBtn) => {
        checkoutBtn.disabled = null;
      });
    }

    document.querySelectorAll('.discount-remove').forEach((rmBtn) => {
      rmBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.target.blur();

        let current_discounts = document.querySelector('[name="current_discounts"]')?.value;

        if (!current_discounts) {
          popupMessage('Could not remove discount.', 'error');
          return;
        }

        current_discounts = current_discounts.split(',');
        current_discounts = current_discounts.filter((e) => e.toLowerCase() !== rmBtn.dataset.discount.toLowerCase());

        document.querySelector('[name="current_discounts"]').value = current_discounts.join(',');
        document.querySelector('[name="discount_code"]').value = ' ';

        document.getElementById('update-button').click();
      });
    });
  }
  initCart();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;

          const slider = document.querySelector('.product-recommendations');
          const slideshow = new Glide(slider, {
            type: 'carousel',
            gap: 0,
            startAt: 0,
            perView: 5,
            autoplay: false,
            breakpoints: {
              1200: {
                perView: 4,
              },
              1000: {
                perView: 3,
              },
              768: {
                perView: 2,
              },
            },
          });
          slideshow.mount();
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
